(() => {
  'use strict';
  const root = () => window.Shopify?.routes?.root || window.Tizico?.rootUrl || '/';
  const parse = element => { try { return JSON.parse(element?.textContent || 'null'); } catch { return null; } };
  function variant() {
    const section = document.querySelector('[data-tizico-product]');
    const product = parse(section?.querySelector('[data-product-json]'));
    const selected = section?.querySelector('[data-variant-select]')?.value;
    return product?.variants.find(item => String(item.id) === selected);
  }
  function selectedItems(bundle, current) {
    const items = [{ id: current?.id, quantity: 1, price: current?.price || 0 }];
    bundle.querySelectorAll('[data-accessory]').forEach(row => {
      const include = row.querySelector('[data-accessory-include]');
      const option = row.querySelector('[data-accessory-variant]')?.selectedOptions[0];
      if (include?.checked && !include.disabled && option && !option.disabled) items.push({ id: Number(option.value), quantity: 1, price: Number(option.dataset.price) });
    });
    return items;
  }
  function sync() {
    document.querySelectorAll('[data-comparison-link]').forEach(link => { link.hidden = !document.getElementById('product-comparison'); });
    document.querySelectorAll('.compare-picker,.accessory-check').forEach(element => { element.hidden = false; });
    const current = variant();
    if (!current) return;
    document.querySelectorAll('[data-restock-area]').forEach(area => { area.hidden = current.available; });
    document.querySelectorAll('[data-support-variant]').forEach(input => { input.value = `${current.title} (${current.id})`; });
    document.querySelectorAll('[data-product-bundle]').forEach(bundle => {
      const items = selectedItems(bundle, current);
      const summary = bundle.querySelector('[data-bundle-summary]');
      summary.hidden = items.length < 2;
      const mainPending = document.querySelector('[data-tizico-product-form]')?.getAttribute('aria-busy') === 'true';
      bundle.querySelector('[data-bundle-add]').disabled = bundle.dataset.busy === 'true' || !current.available || mainPending || items.length < 2;
      const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const currency = bundle.dataset.currency || window.Tizico?.currency;
      try { bundle.querySelector('[data-bundle-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(total / 100); }
      catch { summary.hidden = true; }
    });
  }
  async function addBundle(bundle) {
    const current = variant(), items = selectedItems(bundle, current);
    const mainForm = document.querySelector('[data-tizico-product-form]');
    if (bundle.dataset.busy === 'true' || mainForm?.getAttribute('aria-busy') === 'true' || !current?.available || items.length < 2) return;
    bundle.dataset.busy = 'true';
    bundle.setAttribute('aria-busy', 'true');
    const button = bundle.querySelector('[data-bundle-add]'), status = bundle.querySelector('[data-bundle-status]');
    const controls = [...bundle.querySelectorAll('input,select,button'), ...document.querySelectorAll('[data-product-submit],[data-sticky-add],[data-variant-choice],[data-buy-now]')];
    const disabled = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    const express = document.querySelector('[data-product-express]');
    const expressHidden = express?.hidden;
    if (express) express.hidden = true;
    button.textContent = bundle.dataset.adding;
    status.textContent = '';
    try {
      const response = await fetch(`${root()}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items.map(({ id, quantity }) => ({ id, quantity })) }) });
      if (!response.ok) throw new Error('cart');
      await response.json();
      document.dispatchEvent(new CustomEvent('tizico:cart-added'));
    } catch { status.textContent = bundle.dataset.error; }
    finally {
      delete bundle.dataset.busy;
      bundle.removeAttribute('aria-busy');
      controls.forEach((control, index) => { control.disabled = disabled[index]; });
      if (express) express.hidden = expressHidden;
      button.textContent = bundle.dataset.addLabel;
      sync();
    }
  }
  function init() {
    document.addEventListener('tizico:variant-changed', sync);
    const form = document.querySelector('[data-tizico-product-form]');
    if (form) new MutationObserver(sync).observe(form, { attributes: true, attributeFilter: ['aria-busy'] });
    document.addEventListener('change', event => {
      const target = event.target;
      if (target.matches('[data-accessory-include],[data-accessory-variant]')) sync();
      if (target.matches('[data-compare-toggle]')) {
        const section = target.closest('#product-comparison');
        const toggles = [...section.querySelectorAll('[data-compare-toggle]')];
        if (!toggles.some(toggle => toggle.checked)) target.checked = true;
        section.querySelectorAll('[data-compare-column]').forEach(cell => { if (cell.dataset.compareColumn === target.dataset.compareToggle) cell.hidden = !target.checked; });
      }
    });
    document.addEventListener('click', event => { const button = event.target.closest('[data-bundle-add]'); if (button) addBundle(button.closest('[data-product-bundle]')); });
    document.addEventListener('shopify:section:load', sync);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
